import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
  component: React.ComponentType;
  scopes: string[];
  modules: string[];
}


const RouteGuard: React.FC<Props> = ({ component: Component, scopes, modules }: Props) => {
  const location = useLocation();
  const storedScope = sessionStorage.getItem('permissionScopes');
  console.log("storedScope***:", storedScope);
  const storedModules = sessionStorage.getItem('permissionModule');
  console.log("storedModules***:", storedModules);

  useEffect(() => {
    if (!scopes.includes(storedScope!) && !modules.includes(storedModules!)) {
      window.location.href ='/loginlanding';
    }
    // if (!storedScope || !storedModules) {
    //   window.location.href = '/loginlanding';
    // } else if (!scopes.includes(storedScope) || !modules.includes(storedModules)) {
    //   window.location.href = '/errorpages';
    // }
  }, [location, scopes, storedScope, modules, storedModules]);

  return <Component />;
};

export default RouteGuard;






